<template>
    <div
        :class="{'chosen-container-active chosen-with-drop' : isOpen, 'chosen-disabled' : disabled}"
        class="chosen-container chosen-container-single chosen-container-single-nosearch"
        style="--min-width: 350px;"
        v-click-outside="close"
    >
        <a @click="isOpen = true" class="chosen-single">
            <!-- Doplnit vybraný prvek - jeho duplikát -->
            <span v-if="!value">
                <slot name="selectText"></slot>
            </span>
            <span v-else v-html="selectedText">

            </span>
            <div>
                <b></b>
            </div>
        </a>
        <div class="chosen-drop">
            <ul class="chosen-results">
                <li></li><!-- WARNING první je hidden-->
                <!-- Vybraný prvek - má třídu highlighted-->
                <li
                    :class="{
                        'active-result' : true,
                        'result-selected highlighted': value === item[identifier]
                     }"
                    class="text-nowrap"
                    :key="item[identifier]"
                    @click="setValue(item[identifier])"
                    v-for="item in values"
                    :ref="'item' + item[identifier]"
                >
                    <slot name="item" v-bind:item="item"></slot>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "ChosenSelect",
    props: {
        values: {
            type: Array
        },
        value: {

        },
        identifier: {
           default: 'id',
           type: String
        },
        disabled: {
            default: false,
            type: Boolean
        }
    },
    computed: {

    },
    data() {
       return {
           isOpen: false,
           selectedText: '',
       }
    },
    watch: {
        value(newVal){
            this.selected(newVal)
       },
        values() {
            var _this = this;
            this.$nextTick(
                function () {
                    _this.selected(_this.value);
                }
            )
        }
    },
    methods: {
        selected(value) {
            if(!value) {
                return '';
            }
            this.selectedText = this.$refs['item' + value][0].innerHTML;
        },
        setValue(itemId) {
            this.$emit('input', itemId);
            this.isOpen = false;
        },
        close() {
            this.isOpen = false;
        }
    },
    created() {
        var _this = this;
        this.isOpen = true;
        this.$nextTick(
            function () {
                _this.selected(_this.value);
                _this.isOpen = false;
            }
        )

        this.$emit('loadDefaultValue', this.value);
    }
}
</script>

<style scoped>

</style>
